/**
 * 문자열을 kebab-case 형식의 slug로 변환합니다.
 * 한글·영문·숫자 등 유니코드 문자를 유지하고, 특수 문자만 제거합니다.
 */
export function generateSlug(text: string): string {
  if (!text || typeof text !== 'string') return '';
  const trimmed = text.trim();
  if (!trimmed) return '';
  // \p{L}=문자(한글/영문 등), \p{N}=숫자. 유지하고 나머지(특수문자 등) 제거
  const withoutSpecial = trimmed.replace(/[^\p{L}\p{N}\s-]/gu, '');
  return withoutSpecial
    .replace(/\s+/g, '-')     // 공백을 하이픈으로 변경
    .replace(/-+/g, '-')     // 중복 하이픈 제거
    .replace(/^-+|-+$/g, '') // 앞뒤 하이픈 제거
    .toLowerCase()           // 영문은 소문자 (한글 등은 그대로)
    || '';
}

/**
 * 카테고리 상세 URL 경로 반환 (예: /category/1-electronics, /category/1-전자제품)
 */
export function getCategoryPath(id: number, name: string): string {
  const nameSlug = name ? generateSlug(name) : '';
  const slug = nameSlug ? `${id}-${nameSlug}` : String(id);
  return `/category/${slug}`;
}

/**
 * URL slug에서 카테고리 ID 추출 (예: "1-electronics" -> 1, "1" -> 1)
 */
export function getCategoryIdFromSlug(slug: string): number | null {
  if (!slug) return null;
  const idPart = slug.includes('-') ? slug.split('-')[0] : slug;
  const id = parseInt(idPart, 10);
  return Number.isNaN(id) ? null : id;
}

/** 상품 제목 slug용 최대 길이 */
const PRODUCT_TITLE_SLUG_MAX = 60;

/**
 * 상품 상세 URL 경로 반환 (예: /product/123-product-title-slug)
 */
export function getProductPath(id: number, title: string): string {
  const titleSlug = title ? generateSlug(title.slice(0, PRODUCT_TITLE_SLUG_MAX)) : '';
  const slug = titleSlug ? `${id}-${titleSlug}` : String(id);
  return `/product/${slug}`;
}

/**
 * URL slug에서 상품 ID 추출 (예: "123-product-title" -> 123, "123" -> 123)
 */
export function getProductIdFromSlug(slug: string): number | null {
  if (!slug) return null;
  const idPart = slug.includes('-') ? slug.split('-')[0] : slug;
  const id = parseInt(idPart, 10);
  return Number.isNaN(id) ? null : id;
} 